import { captureMessage } from '@sentry/react';
import { debugLogger } from '../helper/debugLogger';
import { deleteMessageOffline } from '../slices/messageInput/messageInputActions/deleteMessageOffline';
import { sendMessagesOffline } from '../slices/messageInput/messageInputActions/sendMessagesOffline';
import deleteMessageEffect from './offlineEffects/deleteMessageEffect';
import sendMessageEffect from './offlineEffects/sendMessageEffect';

/**
 * Handles the 'effect' of an redux-offline action
 */
const offlineEffect =
  ({ gccApiClient, blobStorageClient, videoClient, getStore }) =>
  async (effect, action) => {
    debugLogger('Running effect for action', action);

    switch (action.type) {
      case sendMessagesOffline.type: {
        const dispatch = getStore()?.dispatch;
        if (!dispatch) {
          captureMessage('Fatal! Dispatch is not available', { level: 'error' });
        }
        return sendMessageEffect(effect, action, {
          gccApiClient,
          blobStorageClient,
          videoClient,
          dispatch: getStore().dispatch,
        });
      }
      case deleteMessageOffline.type: {
        return deleteMessageEffect(effect, action, { gccApiClient });
      }
      default: {
        return new Error(`Could not find effect matching actionType='${action.type}'`);
      }
    }
  };

export default offlineEffect;
